

































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiFlux from '@/api/flux'
import EditDiscountRatio from '@/components/flux/edit/EditDiscountRatio.vue'
import { AloDiscountRatio } from '@/models/alo/AloDiscountRatio'
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { directPayloadQuery } from '@/utils/api'

@Component({
  name: 'ReadDiscountRatio',    
  components:{EditDiscountRatio},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    discountItems:{
      type:Array,
      default:[],
      required:true
    },
    fluxId:{
      type:Number,
      default:0,
      required:true
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadDiscountRatio extends Vue {
  
  private discountItems!:Array<AloDiscountRatio>
  private loading!:boolean
  private fluxId!:number

  private headersCat = [
    { text: 'Univers', value: 'univers', width:'30%'  },
    { text: 'Rubrique', value: 'rubrique', width:'30%'  },
    // { text: 'Famille', value: 'famille', width:'32%' },
    { text: 'Marque', value: 'marque', width:'30%' },
    { text: 'Remise (%)', value: 'discountRatio', width:'10%' },
    { text: '', value: 'action', width:20 },
  ]
  

  get title() {
    return "Remises par catégories / marques"
  }

  
  edit() { (this.$refs.editDiscountRatio as EditDiscountRatio).edit(this.discountItems,this.fluxId) }


  get items(){
    return this.extendDiscountRatio(this.discountItems)
  }

  itemRowBackground(item:any) {
     return item.isAlive? '' : 'red--text'
  }
 
  extendDiscountRatio(items:Array<AloDiscountRatio>){
    return items.map(it => {
      return {
        ...it,
        isAlive:(it.itfTypObj==ItemfluxObjectType.Univers?this.univers[it.discountFid ].uniIsAlive:(it.itfTypObj==ItemfluxObjectType.Rubrique?this.rubriques[it.discountFid ].rubIsAlive:this.familles[it.discountFid ].famIsAlive)),
        univers:(it.itfTypObj==ItemfluxObjectType.Univers?this.univers[it.discountFid ].libelle:
                  (it.itfTypObj==ItemfluxObjectType.Rubrique)?this.univers[this.rubriques[it.discountFid ].uniId].libelle:
                  this.univers[this.familles[it.discountFid ].uniId].libelle),
        rubrique:(it.itfTypObj==ItemfluxObjectType.Univers?'':
                  (it.itfTypObj==ItemfluxObjectType.Rubrique)?this.rubriques[it.discountFid ].libelle:
                  this.rubriques[this.familles[it.discountFid ].rubId].libelle),
        famille:it.itfTypObj==ItemfluxObjectType.Famille?this.familles[it.discountFid ].libelle:'',
        marque:it.mrqId?(this.marques[it.mrqId]?.libelle ?? '-'):''
      }
    }).sort((a,b) => (a.univers+a.rubrique+a.famille).localeCompare(b.univers+b.rubrique+b.famille))
  }

  get univers(){
    return this.$store.myGetters.univers
  }

  get rubriques(){
    return this.$store.myGetters.rubriques
  }

  get familles(){
    return this.$store.myGetters.familles
  }

  get marques() {
    return this.$store.myGetters.marques
  }

  deleteDiscountRatio(item:any) {
    this.$confirm(`Voulez vous vraiment supprimer le discount : '${item.univers} ${item.rubrique?'/':''} ${item.rubrique} ${item.famille?'/':''} ${item.famille}' ${item.marque?` - ${item.marque}`:''}  (${item.discountRatio}%) du flux?`
                  ,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
      if(answer) {                       
        const idx = this.discountItems.findIndex(it => /*it.id == item.id*/  it.mrqId == item.mrqId && it.itfTypObj == item.itfTypObj && it.discountFid == item.discountFid  )     
        if(idx > -1)  {
          this.$set(item,"deleted",true);          
          this.discountItems.splice(idx,1)
          directPayloadQuery(apiFlux.saveDiscountRatio,{id:this.fluxId,discountItems:this.discountItems},this.$store)                    
        }        
      }
    })
  }

}
